import Payments from '../../../../api/api-payments';
import { Profile } from '../../../../api/api-profile';

/**
 * fetchIdvStatus
 * @param SSOid string
 * @param accessToken string
 * */
export const fetchIdentitySession = (SSOid, accessToken) => {
  return new Promise((resolve, reject) => {
    Payments.getIdentitySession(SSOid, accessToken, (response) => {
      if (response?.error || 400 <= response?.statusCode) {
        reject(response);
        return;
      }
      resolve(response);
    });
  });
};

/**
 * fetchIdvStatus
 * @param SSOid string
 * @param accessToken string
 * @param payload object
 * */
export const createIdentitySession = (SSOid, accessToken, payload) => {
  return new Promise((resolve, reject) => {
    Payments.createIdentitySession(SSOid, accessToken, payload, (response) => {
      if (response?.error || 400 <= response?.statusCode) {
        reject(response);
        return;
      }
      resolve(response);
    });
  });
};

/**
 * fetchIdvStatus
 * @param SSOid string
 * @param accessToken string
 * @param triggerType string - IDV_TRIGGER_TYPES (./idv.consts.js)
 * */
export const fetchIdvStatus = (SSOid, accessToken, triggerType) => {
  return new Promise((resolve, reject) => {
    Profile.getIdvStatus(SSOid, accessToken, triggerType, (response) => {
      if (response?.error || 400 <= response?.statusCode) {
        reject(response);
        return;
      }
      resolve(response);
    });
  });
};